// extracted by mini-css-extract-plugin
export const section = "index-module--section--egTkv";
export const container = "index-module--container--2IQON";
export const pageContent = "index-module--pageContent--2g9qC";
export const footer = "index-module--footer--1hvJN";
export const modal = "index-module--modal--1kYfP";